// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, useMediaQuery} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {InfoOutlined} from '@material-ui/icons';
import {Tooltip as MUITooltip} from '@material-ui/core';

type Props = {
  title: string,
  placement?: string,
};

const useStyles = makeStyles(theme => ({
  actionButtonInfoIcon: {
    color: colors.purple,
  },
  infoTooltip: {
    color: colors.purple3,
    backgroundColor: colors.lightPurple,
    borderRadius: '8px',
    textAlign: 'left',
    maxWidth: 320,
  },
}));
export default function Tooltip(props: Props) {
  const {title, placement} = props;
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  return (
    <MUITooltip
      classes={{tooltip: classes.infoTooltip}}
      placement={placement ? placement : isMobile ? 'right' : 'left'}
      title={title}
    >
      <InfoOutlined color="primary" className={classes.actionButtonInfoIcon} />
    </MUITooltip>
  );
}

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  placement: PropTypes.string,
};
